import { useEffect, useState } from "react";
import { authService } from "./service/authService";
import LoginPage from "./pages/LoginPage/LoginPage";
import HomePage from "./pages/HomePage/HomePage";
import { Route, Switch } from "react-router-dom";

function App() {
  const [tokenState, setTokenState] = useState(authService.tokenValue);

  useEffect(() => {
    authService.setAccessTokenFromLocalStorage();
    authService.currentToken.subscribe(setTokenState);
  }, []);

  const isLoggedIn = () => {
    return tokenState !== "";
  };
  return (
    <>
      {!isLoggedIn() && (
        <Switch>
          <Route path="/" component={LoginPage} />
        </Switch>
      )}
      {isLoggedIn() && (
        <Switch>
          <Route path="/" component={HomePage} />
        </Switch>
      )}
    </>
  );
}

export default App;
